const fonts = require('./fonts/fonts');
const fontsData = require('./fonts/fontMetaData');

const post = {
    get_HTML: (item, settings) => {
        let descriptionLength = settings.props.descriptionLength;
        let description = settings.props.description;
        let clickBehavior = settings.props.clickBehavior;
        if (!settings.props.desktop) {
            descriptionLength = settings.props.m_descriptionLength;
            description = settings.props.m_description;
            clickBehavior = settings.props.m_clickBehavior;
        }
        const formatNumber = (num) => { return num < 1e3 ? `${num}` : num < 1e6 ? `${(num / 1e3).toFixed(1).replace(/\.0$/, '')}K` : `${(num / 1e6).toFixed(1).replace(/\.0$/, '')}M`; };
        return `<div class="post-item">
                    <div class="image-wrap">
                        <img src="${item.thumbnailURL}" style="fetchpriority="high" loading="lazy" alt="Post Image">
                        <div class="gradient"></div>
                        <div class="play-icon">
        	            		<span class="plays${settings.props.views?"":" hide"}">${formatNumber(Number(item.counters.plays))} ▶</span>
        	            	</div>
                        <div class="post-meta">
                            <span class="likes${settings.props.likes?"":" hide"}">${formatNumber(Number(item.counters.diggs))} ❤</span>
                            <span class="comments${settings.props.comments?"":" hide"}">${formatNumber(Number(item.counters.comments))} 💬</span>
                            <span class="shares${settings.props.shares?"":" hide"}">${formatNumber(Number(item.counters.shares))} ⮫</span>
                        </div>
                        ${clickBehavior === "tiktok"?`<a style="position:absolute;top:0;left:0;height:100%;width:100%;" href="${item.user.url}" target="_blank"></a>`:''}
                        ${!settings.props.watermark?post.smallWaterMark():""}
                    </div>
                    <div class="post-caption${descriptionLength==="short"?" cut":""}${description?"":" hide"}">${item.text}<a class="read-more">...</a></div>
                 </div>`
    },
    smallWaterMark: () => {
        return `<a class="smallWaterMark" href="https://www.prpl.io/" target="_blank">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="36px" height="36px" viewBox="0 0 36 36" style="enable-background:new 0 0 36 36;" xml:space="preserve">
                    <style type="text/css">
                    	.st0{fill:#FFFFFF;fill-opacity:0.3;}
                    	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
                    </style>
                        <path class="st0" d="M3.3,0h29.5C34.5,0,36,1.5,36,3.3v29.5c0,1.8-1.5,3.3-3.3,3.3H3.3C1.5,36,0,34.5,0,32.7V3.3C0,1.5,1.5,0,3.3,0z"/>
                        <path class="st1" d="M9.7,12h4.9V7.1H9.7V12z"/>
                        <path class="st1" d="M16.6,14.1h4.9V9.2h-4.9V14.1z"/>
                        <path class="st1" d="M11.7,19h4.9v-4.9l-4.9,0V19z"/>
                        <path class="st1" d="M21.4,24h4.9V19h-4.9V24z"/>
                        <path class="st1" d="M21.4,14.1h4.9V9.2h-4.9V14.1z"/>
                        <path class="st1" d="M16.6,24h4.9V19l-4.9,0V24z"/>
                        <path class="st1" d="M11.7,28.9h4.9V24l-4.9,0V28.9z"/>
                        <path class="st1" d="M21.4,19h4.9v-4.9h-4.9V19z"/>
                        <path class="st1" d="M11.7,24l4.9,0V19h-4.9V24z"/>
                    </svg>
                </a>`
    },
    get_CSS_Slider: (settings) => {
        let bgColor = settings.props.widgetBackGroundColor;
        let radius = settings.props.cornerRadius + "px";
        if (!settings.props.desktop) {
            bgColor = settings.props.m_widgetBackGroundColor;
            radius = settings.props.m_cornerRadius + "px";
        }
        return `
        ${post.font_import(settings.props.font)}
        .post-item {
            cursor: ${settings.props.clickBehavior === "nothing"? "auto !important":"pointer !important"};
            font-family:${settings.props.font};
            margin-bottom: 20px;
            background: ${settings.props.itemBackGroundColor};
            border-radius: ${settings.props.cornerRadius}px;
        }
        .hide{
            display: none !important;
        }
        .widget-wrapper{
            width: 100%; 
            height: max-content; 
            min-height: 140px;
            background:  ${bgColor};
            border-radius:  ${radius};
        }
        .image-wrap {
            font-size: ${settings.props.fontLabelsSize}px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            position: relative;
            width: 100%;
            aspect-ratio: ${settings.props.ratio};
            overflow: hidden;
            border-radius: ${settings.props.cornerRadius}px;
        }
        .cut {   
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .image-wrap img {
            background: #EEEEEE;
            position: absolute;
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform .5s ease-in-out;
            -webkit-transition: -webkit-transform .5s ease-in-out; /* For Safari compatibility */
            transform-origin: center;
        }
        .image-wrap:hover img {
            transform: scale(1.1); 
        }
        .likes, .comments, .shares, .plays {
            margin-bottom: 3%;
            color: ${settings.props.labelsColor};
        }
        .play-icon, .post-meta {
            position: relative;
            color: #fff;
            width: 90%;
            display: flex;
            flex-wrap: wrap;
            gap: 3%;
            margin-left: 5%;
            display: flex;
        }
        .post-caption {
            font-size: ${settings.props.fontSize}px;
            line-height: 1.4em;
            color: ${settings.props.descriptionColor};
            margin-top: 12px;
            margin-bottom: 6px;
        }
        .gradient{
        	background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.4));
            position:absolute;
            top:0;
            height:100%;
            width:100%;
        }
        .splide:active {
            cursor: grabbing !important;
            cursor: -moz-grabbing !important;
            cursor: -webkit-grabbing !important;
        }
        .splide a:active {
            cursor: grabbing !important;
            cursor: -moz-grabbing !important;
            cursor: -webkit-grabbing !important;
        }
        .splide__pagination__page.is-active {
            background: #606060 !important;
        }
        .smallWaterMark{
            position: absolute;
            top: 4px;
            right: 4px;
        }
        /*
        @media (max-width: 599px) {
            ${post.font_import(settings.props.m_font)}
            .post-item {
                font-family:${settings.props.m_font};
                background: ${settings.props.m_itemBackGroundColor};
                border-radius: ${settings.props.m_cornerRadius}px;
            }
            .image-wrap {
                font-size: ${settings.props.m_fontLabelsSize}px;
                aspect-ratio: ${settings.props.m_ratio};
                border-radius: ${settings.props.m_cornerRadius}px;
            }
            .likes, .comments, .shares, .plays {
                color: ${settings.props.m_labelsColor};
            }
            .post-caption {
                font-size: ${settings.props.m_fontSize}px;
                color: ${settings.props.m_descriptionColor};
            }
        }
        */
        .splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:-ms-flexbox;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__arrow{-ms-flex-align:center;align-items:center;background:#ccc;border:0;border-radius:50%;cursor:pointer;display:-ms-flexbox;display:flex;height:2em;-ms-flex-pack:center;justify-content:center;opacity:.7;padding:0;position:absolute;top:40%;transform:translateY(-50%);width:2em;z-index:1}.splide__arrow svg{fill:#000;height:1.2em;width:1.2em}.splide__arrow:hover:not(:disabled){opacity:.9}.splide__arrow:disabled{opacity:.3}.splide__arrow:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide__arrow--prev{left:1em}.splide__arrow--prev svg{transform:scaleX(-1)}.splide__arrow--next{right:1em}.splide.is-focus-in .splide__arrow:focus{outline:3px solid #0bf;outline-offset:3px}.splide__pagination{bottom:-2em;left:0;padding:0 1em;position:absolute;right:0;z-index:1}.splide__pagination__page{background:#ccc;border:0;border-radius:50%;display:inline-block;height:8px;margin:3px;opacity:.7;padding:0;position:relative;transition:transform .2s linear;width:8px}.splide__pagination__page.is-active{background:#fff;transform:scale(1.4);z-index:1}.splide__pagination__page:hover{cursor:pointer;opacity:.9}.splide__pagination__page:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__pagination__page:focus{outline:3px solid #0bf;outline-offset:3px}.splide__progress__bar{background:#ccc;height:3px}.splide__slide{-webkit-tap-highlight-color:rgba(0,0,0,0)}.splide__slide:focus{outline:0}@supports(outline-offset:-3px){.splide__slide:focus-visible{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide__slide:focus-visible{border:3px solid #0bf}}@supports(outline-offset:-3px){.splide.is-focus-in .splide__slide:focus{outline:3px solid #0bf;outline-offset:-3px}}@media screen and (-ms-high-contrast:none){.splide.is-focus-in .splide__slide:focus{border:3px solid #0bf}.splide.is-focus-in .splide__track>.splide__list>.splide__slide:focus{border-color:#0bf}}.splide__toggle{cursor:pointer}.splide__toggle:focus-visible{outline:3px solid #0bf;outline-offset:3px}.splide.is-focus-in .splide__toggle:focus{outline:3px solid #0bf;outline-offset:3px}.splide__track--nav>.splide__list>.splide__slide{border:3px solid transparent;cursor:pointer}.splide__track--nav>.splide__list>.splide__slide.is-active{border:3px solid #000}.splide__arrows--rtl .splide__arrow--prev{left:auto;right:1em}.splide__arrows--rtl .splide__arrow--prev svg{transform:scaleX(1)}.splide__arrows--rtl .splide__arrow--next{left:1em;right:auto}.splide__arrows--rtl .splide__arrow--next svg{transform:scaleX(-1)}.splide__arrows--ttb .splide__arrow{left:50%;transform:translate(-50%)}.splide__arrows--ttb .splide__arrow--prev{top:1em}.splide__arrows--ttb .splide__arrow--prev svg{transform:rotate(-90deg)}.splide__arrows--ttb .splide__arrow--next{bottom:1em;top:auto}.splide__arrows--ttb .splide__arrow--next svg{transform:rotate(90deg)}.splide__pagination--ttb{bottom:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;left:auto;padding:1em 0;right:.5em;top:0}
        `;
    },
    get_CSS_Grid: (settings) => {
        let columns = settings.props.columns;
        let spacing = settings.props.spacing;
        let m_columns = settings.props.m_columns;
        let m_spacing = settings.props.m_spacing;
        let bgColor = settings.props.widgetBackGroundColor;
        let radius = settings.props.cornerRadius + "px";
        if (!settings.props.desktop) {
            bgColor = settings.props.m_widgetBackGroundColor;
            radius = settings.props.m_cornerRadius + "px";
        }
        return `
        ${post.font_import(settings.props.font)}
        .post-item {
            cursor: ${settings.props.clickBehavior === "nothing"? "auto !important":"pointer !important"};
            font-family:${settings.props.font};
            width: 100%;
            background: ${settings.props.itemBackGroundColor};
            border-radius: ${settings.props.cornerRadius}px;
        }
        .widget-wrapper{
            width: 100%; 
            height: max-content; 
            min-height: 140px;
            background:  ${bgColor};
            border-radius:  ${radius};
        }
        .load-more-button {
            font-family:${settings.props.font};
            margin-top: 20px;
            padding: 15px 0px 15px 0px;
            background: ${settings.props.buttonBackGroundColor};
            align-items: center;
            border: 0;
            border-radius: 4px;
            box-shadow: 0 2px 5px rgba(60,66,87,.12), 0 1px 1px rgba(0,0,0,.08), inset 0 -1px 1px rgba(0,0,0,.12);
            cursor: pointer;
            display: flex;
            justify-content: center;
            outline: none;
            position: relative;
            transition: all .15s ease-in-out;
            color: ${settings.props.buttonTextBackGroundColor};
            border-radius: ${settings.props.m_cornerRadius}px;
            width: 100%;
        }
        .load-more-button:hover {
            background: ${settings.props.buttonHoverBackGroundColor};
            color: ${settings.props.buttonTextHoverBackGroundColor};
        }
        .wrapper{
            display: flex;
            flex-wrap: wrap;
            flex-direction: ${settings.props.direction === "ltr"?"row":"row-reverse"};
            align-content: flex-start;
            justify-content: flex-start;
            gap: ${spacing}px;
        }
        .item-wrap{
            width: calc(${100/columns}% - ${((columns-1)*spacing)/columns}px);
        }
        .hide{
            display: none !important;
        }
        .image-wrap {
            font-size: ${settings.props.fontLabelsSize}px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            position: relative;
            width: 100%;
            aspect-ratio: ${settings.props.ratio};
            overflow: hidden;
            border-radius: ${settings.props.cornerRadius}px;
        }
        .cut {   
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .image-wrap img {
            background: #EEEEEE;
            position: absolute;
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform .5s ease-in-out;
            -webkit-transition: -webkit-transform .5s ease-in-out; /* For Safari compatibility */
            transform-origin: center;
        }
        .image-wrap:hover img {
            transform: scale(1.1); 
        }
        .likes, .comments, .shares, .plays {
            margin-bottom: 3%;
            color: ${settings.props.labelsColor};
        }
        .play-icon, .post-meta {
            position: relative;
            color: #fff;
            width: 90%;
            display: flex;
            flex-wrap: wrap;
            gap: 3%;
            margin-left: 5%;
            display: flex;
        }
        .post-caption {
            font-size: ${settings.props.fontSize}px;
            line-height: 1.4em;
            color: ${settings.props.descriptionColor};
            margin-top: 12px;
            margin-bottom: 6px;
        }
        .gradient{
        	background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.4));
            position:absolute;
            top:0;
            height:100%;
            width:100%;
        }
        .smallWaterMark{
            position: absolute;
            top: 4px;
            right: 4px;
        }
        /*
        @media (max-width: 599px) {
            ${post.font_import(settings.props.m_font)}
            .post-item {
                font-family:${settings.props.m_font};
                background: ${settings.props.m_itemBackGroundColor};
                border-radius: ${settings.props.m_cornerRadius}px;
            }
            .image-wrap {
                font-size: ${settings.props.m_fontLabelsSize}px;
                aspect-ratio: ${settings.props.m_ratio};
                border-radius: ${settings.props.m_cornerRadius}px;
            }
            .item-wrap{
                width: calc(${100/m_columns}% - ${((m_columns-1)*m_spacing)/m_columns}px);
            }
            .likes, .comments, .shares, .plays {
                color: ${settings.props.m_labelsColor};
            }
            .post-caption {
                font-size: ${settings.props.m_fontSize}px;
                color: ${settings.props.m_descriptionColor};
            }
            .load-more-button {
                background: ${settings.props.m_buttonBackGroundColor};
                color: ${settings.props.m_buttonTextBackGroundColor};
                border-radius: ${settings.props.m_cornerRadius}px;
            }
            .load-more-button:hover {
                background: ${settings.props.m_buttonHoverBackGroundColor};
                color: ${settings.props.m_buttonTextHoverBackGroundColor};
            }
        }
        */`
    },
    font_import: (font) => {
        let fontKey = fontsData[font].fontFamily;
        let result = fonts.getFontsUrlWithParams({
            [fontKey]: fontsData[font]
        }, "WixSite");
        if (result.startsWith("//")) result = `@import url('${result}');`
        return result;
    },
    create_lightbox: (item) => {
        return `
            <style>
            .lightbox-wraper {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 1000000; 
            }
            .lightbox{
            	position: relative;
            	display: flex;
                align-items: flex-start;
                min-width: 330px!important;
                background: white;
                max-height: 100%;
            }
            .lightbox-bg{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
            }
            .lightbox-content-left {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 758px;
            	min-width: 330px;
                width: 50vw;
                max-width: 660px;
                background-color: black;
            }
            .lightbox-content-right {
            	padding: 24px;
                max-width: 330px;
                min-width: 330px;
            }
            .close-btn {
            	cursor: pointer;
                position: absolute;
                right: 0px;
                width: 26px;
                border: none;
                background: white;
                border-radius: 10%; 
                font-size: 20px;
            }
            .tiktok-embed{
                font-size: 14px;
            }
            .header{
            	display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 12px;
                text-decoration: none;
                margin-bottom: 15px;
            }
            .header img{
            	border-radius: 50%;
            	object-fit: cover;
            	height: 33px;
            	width: 33px;
            }
            .header p1{
            	font-size: 14px;
            	font-weight: 600;
            	line-height: 120%;
            	letter-spacing: 0.28px;
            	color: black;
            	margin-bottom: 0px;
            }
            .header p2{
            	color: gray;
            	font-size: 11px;
            	font-weight: 400;
            	margin-top: 0px;
            }
            .header div{
            	display: flex;
                flex-direction: column;
            }
            @media (max-width: 750px){
                .lightbox-content-right{
            		display:none;
            	}
                .lightbox-content-left{
                	width: 330px;
            	}
            }
            </style>
            <div class="lightbox-wraper">
                <div class="lightbox-bg" onclick="this.parentElement.parentElement.remove()"></div>
            	<div class="lightbox">
                	<button class="close-btn" onclick="this.parentElement.parentElement.parentElement.remove()">✖</button>
                	<div class="lightbox-content-left">
            			<iframe src="https://www.tiktok.com/embed/v2/${item.id}" height="758px" width="330px" style="border: none; visibility: unset; margin: 0px auto;"></iframe>
                	</div>
                    <div class="lightbox-content-right">
                    <a class="header" href="${item.user.url}" target="_blank"> 
		            	<img src="${item.user.image}">
		            	<div>
		            		<p1 style="">@${item.user.name}</p1>
		            		<p2 style="">${new Date(item.publishedAt * 1000).toISOString().split('T')[0].replace(/-/g, '-')}</p2>
		            	</div>
		            </a>
                 	${item.videoEmbed}
                	</div>
                </div>

            </div>
        `
    }
}
const apply_font = (document,settings)=>{
    const style = document.createElement('style');
    style.textContent = post.font_import(settings.props.font);
    document.head.appendChild(style);
}

export const create_Slider = (document, settings, sliderID) => {
    apply_font(document,settings);
    let sectionWrapper = document.createElement('div');
    sectionWrapper.setAttribute("class", "widget-wrapper");
    let mainHolder = document.createElement('section');
    mainHolder.setAttribute("class", "splide");
    mainHolder.setAttribute("id", sliderID);
    mainHolder.setAttribute("aria-label", "TikTok Feed");

    let splideTrack = document.createElement('div');
    splideTrack.setAttribute("class", "splide__track");

    let myStyle = document.createElement('style');
    let myUl = document.createElement('ul');
    myUl.setAttribute("class", "splide__list");
    if (settings.props.direction === "rtl") settings.data = settings.data.reverse();
    settings.data.forEach((item) => {
        let li = document.createElement("li");
        li.setAttribute("class", "splide__slide");
        li.innerHTML = post.get_HTML(item, settings)
        if(settings.props.clickBehavior === "lightbox") create_Lightbox(document, li.firstChild, item);
        myUl.appendChild(li);

    });

    myStyle.innerHTML = post.get_CSS_Slider(settings)

    splideTrack.appendChild(myStyle);
    splideTrack.appendChild(myUl);
    mainHolder.appendChild(splideTrack);
    sectionWrapper.appendChild(mainHolder);
    return sectionWrapper;
}

export const create_Grid = (document, settings) => {
    apply_font(document,settings);
    let sectionWrapper = document.createElement('div');
    sectionWrapper.setAttribute("class", "widget-wrapper");
    sectionWrapper.setAttribute("style", "min-height:140px;");
    let section = document.createElement('section');
    section.setAttribute("aria-label", "TikTok Feed");

    let gridWrapper = document.createElement('div');
    gridWrapper.setAttribute("class", "wrapper");

    let myStyle = document.createElement('style');
    myStyle.innerHTML = post.get_CSS_Grid(settings)
    section.appendChild(myStyle);
    let button;
    let trimmedArray = JSON.parse(JSON.stringify(settings.data));
    const itemsToDisplay = settings.props.rows * settings.props.columns;

    if (settings.props.loadMore && trimmedArray.length > itemsToDisplay) {
        button = document.createElement('button');
        button.setAttribute("class", "load-more-button");
        button.innerHTML = "Load More";
        trimmedArray = JSON.parse(JSON.stringify(settings.data.slice(0, itemsToDisplay)));
        let clicked = 1;
        button.addEventListener('click', function () {
            let limit = itemsToDisplay * (clicked + 1);
            let newItems = JSON.parse(JSON.stringify(settings.data.slice(itemsToDisplay * clicked, limit)));
            newItems.forEach(item => {
                const itemWrap = document.createElement('div');
                itemWrap.className = 'item-wrap';
                itemWrap.innerHTML = post.get_HTML(item, settings);
                if(settings.props.clickBehavior === "lightbox") create_Lightbox(document, itemWrap.firstChild, item);
                gridWrapper.appendChild(itemWrap);
            });
            if (limit >= settings.data.length) section.removeChild(button);
            clicked += 1;
        });
    }

    trimmedArray.forEach(item => {
        const itemWrap = document.createElement('div');
        itemWrap.className = 'item-wrap';
        itemWrap.innerHTML = post.get_HTML(item, settings);
        if(settings.props.clickBehavior === "lightbox") create_Lightbox(document, itemWrap.firstChild, item);
        gridWrapper.appendChild(itemWrap);
    });
    section.appendChild(gridWrapper);
    if (button) section.appendChild(button);
    sectionWrapper.appendChild(section);
    return sectionWrapper;
}

export const create_WaterMark = (document) => {
    let watermarkHost = document.createElement('div');
    let shadowRoot = watermarkHost.attachShadow({ mode: 'open' });
    let watermarkWrapper = document.createElement('div');
    watermarkWrapper.style.display = "flex";
    watermarkWrapper.style.position = "relative";
    watermarkWrapper.style.marginTop = "2em";
    watermarkWrapper.innerHTML = `
        <a href="https://www.prpl.io/" target="_blank">
            <svg width="181" height="32" viewBox="0 0 181 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="180.312" height="32" rx="4" fill="black" fill-opacity="0.3"/>
                <path d="M15.8883 22H14.2403V10.56H18.5123C19.2483 10.56 19.8936 10.6987 20.4483 10.976C21.0029 11.2533 21.4349 11.6427 21.7443 12.144C22.0536 12.6347 22.2083 13.216 22.2083 13.888C22.2083 14.5493 22.0536 15.136 21.7443 15.648C21.4349 16.1493 21.0029 16.5387 20.4483 16.816C19.8936 17.0933 19.2483 17.232 18.5123 17.232H15.8883V22ZM18.5123 11.984H15.8883V15.808H18.5123C19.1416 15.808 19.6376 15.6373 20.0003 15.296C20.3629 14.9547 20.5443 14.4853 20.5443 13.888C20.5443 13.2907 20.3629 12.8267 20.0003 12.496C19.6376 12.1547 19.1416 11.984 18.5123 11.984ZM27.2234 22.256C26.434 22.256 25.73 22.0747 25.1114 21.712C24.5034 21.3493 24.0234 20.848 23.6714 20.208C23.33 19.568 23.1594 18.8427 23.1594 18.032C23.1594 17.2107 23.33 16.48 23.6714 15.84C24.0234 15.2 24.5034 14.6987 25.1114 14.336C25.7194 13.9733 26.418 13.792 27.2074 13.792C28.0074 13.792 28.7114 13.9733 29.3194 14.336C29.938 14.6987 30.418 15.2 30.7594 15.84C31.1114 16.48 31.2874 17.2107 31.2874 18.032C31.2874 18.8427 31.1114 19.568 30.7594 20.208C30.418 20.848 29.9434 21.3493 29.3354 21.712C28.7274 22.0747 28.0234 22.256 27.2234 22.256ZM27.2234 20.88C27.938 20.88 28.514 20.6187 28.9514 20.096C29.3887 19.5627 29.6074 18.8747 29.6074 18.032C29.6074 17.1787 29.3887 16.4907 28.9514 15.968C28.514 15.4347 27.9327 15.168 27.2074 15.168C26.5034 15.168 25.9327 15.4347 25.4954 15.968C25.058 16.4907 24.8394 17.1787 24.8394 18.032C24.8394 18.8747 25.058 19.5627 25.4954 20.096C25.9327 20.6187 26.5087 20.88 27.2234 20.88ZM41.632 22H39.968L38.24 16.16L36.544 22H34.864L32.528 14.048H34.128L35.76 20.272L37.552 14.048H38.992L40.784 20.304L42.432 14.048H44L41.632 22ZM51.8291 19.664L52.7731 20.672C52.3571 21.1947 51.8611 21.5893 51.2851 21.856C50.7198 22.1227 50.1011 22.256 49.4291 22.256C48.5971 22.256 47.8665 22.0747 47.2371 21.712C46.6185 21.3493 46.1331 20.848 45.7811 20.208C45.4291 19.568 45.2531 18.8427 45.2531 18.032C45.2531 17.2213 45.4238 16.496 45.7651 15.856C46.1065 15.216 46.5758 14.7147 47.1731 14.352C47.7705 13.9787 48.4425 13.792 49.1891 13.792C49.9145 13.792 50.5545 13.9733 51.1091 14.336C51.6638 14.688 52.0958 15.1787 52.4051 15.808C52.7251 16.4373 52.8851 17.1573 52.8851 17.968V18.544H46.9331C47.0291 19.2693 47.3011 19.8507 47.7491 20.288C48.1971 20.7147 48.7838 20.928 49.5091 20.928C50.4691 20.928 51.2425 20.5067 51.8291 19.664ZM49.1731 15.12C48.5758 15.12 48.0745 15.328 47.6691 15.744C47.2745 16.1493 47.0345 16.6987 46.9491 17.392H51.2691C51.2051 16.688 50.9865 16.1333 50.6131 15.728C50.2505 15.3227 49.7705 15.12 49.1731 15.12ZM59.4951 13.92V15.424H59.1591C58.4338 15.424 57.8205 15.6853 57.3191 16.208C56.8178 16.72 56.5671 17.536 56.5671 18.656V22H54.9671V14.048H56.5511V15.728C56.8071 15.056 57.1858 14.5867 57.6871 14.32C58.1991 14.0533 58.7058 13.92 59.2071 13.92H59.4951ZM67.0323 19.664L67.9763 20.672C67.5603 21.1947 67.0643 21.5893 66.4883 21.856C65.9229 22.1227 65.3043 22.256 64.6323 22.256C63.8003 22.256 63.0696 22.0747 62.4403 21.712C61.8216 21.3493 61.3363 20.848 60.9843 20.208C60.6323 19.568 60.4563 18.8427 60.4563 18.032C60.4563 17.2213 60.6269 16.496 60.9683 15.856C61.3096 15.216 61.7789 14.7147 62.3763 14.352C62.9736 13.9787 63.6456 13.792 64.3923 13.792C65.1176 13.792 65.7576 13.9733 66.3123 14.336C66.8669 14.688 67.2989 15.1787 67.6083 15.808C67.9283 16.4373 68.0883 17.1573 68.0883 17.968V18.544H62.1363C62.2323 19.2693 62.5043 19.8507 62.9523 20.288C63.4003 20.7147 63.9869 20.928 64.7123 20.928C65.6723 20.928 66.4456 20.5067 67.0323 19.664ZM64.3763 15.12C63.7789 15.12 63.2776 15.328 62.8723 15.744C62.4776 16.1493 62.2376 16.6987 62.1523 17.392H66.4723C66.4083 16.688 66.1896 16.1333 65.8163 15.728C65.4536 15.3227 64.9736 15.12 64.3763 15.12ZM76.1863 22V20.848C75.9196 21.2747 75.5516 21.616 75.0823 21.872C74.6236 22.128 74.0956 22.256 73.4983 22.256C72.7836 22.256 72.1383 22.08 71.5623 21.728C70.9969 21.3653 70.5436 20.864 70.2023 20.224C69.8716 19.584 69.7063 18.8533 69.7063 18.032C69.7063 17.2107 69.8716 16.48 70.2023 15.84C70.5436 15.2 70.9969 14.6987 71.5623 14.336C72.1383 13.9733 72.7783 13.792 73.4823 13.792C74.0796 13.792 74.6076 13.9307 75.0663 14.208C75.5356 14.4747 75.9036 14.832 76.1703 15.28V10.48H77.7703V22H76.1863ZM71.3863 18.032C71.3863 18.5867 71.4876 19.0827 71.6903 19.52C71.9036 19.9467 72.1916 20.2827 72.5543 20.528C72.9276 20.7733 73.3543 20.896 73.8343 20.896C74.3783 20.896 74.8583 20.7413 75.2743 20.432C75.7009 20.112 75.9996 19.7013 76.1703 19.2V18.176C76.1703 17.28 75.9463 16.5547 75.4983 16C75.0609 15.4453 74.4903 15.168 73.7863 15.168C73.3169 15.168 72.9009 15.2907 72.5383 15.536C72.1756 15.7813 71.8929 16.1173 71.6903 16.544C71.4876 16.9707 71.3863 17.4667 71.3863 18.032ZM85.473 22H83.889V10.48H85.489V15.344C85.7557 14.864 86.1237 14.4853 86.593 14.208C87.073 13.9307 87.617 13.792 88.225 13.792C88.9397 13.792 89.5743 13.9733 90.129 14.336C90.6943 14.6987 91.137 15.2 91.457 15.84C91.7877 16.48 91.953 17.2107 91.953 18.032C91.953 18.8533 91.7823 19.584 91.441 20.224C91.1103 20.864 90.657 21.3653 90.081 21.728C89.5157 22.08 88.8757 22.256 88.161 22.256C87.5637 22.256 87.0303 22.128 86.561 21.872C86.1023 21.616 85.7397 21.2747 85.473 20.848V22ZM85.489 18.176V19.2C85.6597 19.7013 85.953 20.112 86.369 20.432C86.7957 20.7413 87.281 20.896 87.825 20.896C88.3157 20.896 88.7423 20.7733 89.105 20.528C89.4783 20.2827 89.7663 19.9467 89.969 19.52C90.1823 19.0827 90.289 18.5867 90.289 18.032C90.289 17.1893 90.0703 16.5013 89.633 15.968C89.2063 15.4347 88.641 15.168 87.937 15.168C87.4677 15.168 87.0463 15.296 86.673 15.552C86.2997 15.7973 86.0063 16.1493 85.793 16.608C85.5903 17.056 85.489 17.5787 85.489 18.176ZM99.1598 14.048H100.776L97.0958 23.184C96.8504 23.8027 96.5358 24.2773 96.1518 24.608C95.7784 24.9387 95.2291 25.104 94.5038 25.104H93.5118V23.76H94.4557C94.8184 23.76 95.0958 23.68 95.2878 23.52C95.4798 23.36 95.6291 23.12 95.7358 22.8L96.0238 22.032L92.8078 14.048H94.4878L96.8078 20.336L99.1598 14.048ZM108.06 22H106.412V10.56H110.684C111.42 10.56 112.065 10.6987 112.62 10.976C113.175 11.2533 113.607 11.6427 113.916 12.144C114.225 12.6347 114.38 13.216 114.38 13.888C114.38 14.5493 114.225 15.136 113.916 15.648C113.607 16.1493 113.175 16.5387 112.62 16.816C112.065 17.0933 111.42 17.232 110.684 17.232H108.06V22ZM110.684 11.984H108.06V15.808H110.684C111.313 15.808 111.809 15.6373 112.172 15.296C112.535 14.9547 112.716 14.4853 112.716 13.888C112.716 13.2907 112.535 12.8267 112.172 12.496C111.809 12.1547 111.313 11.984 110.684 11.984ZM125.46 10.56V17.488C125.46 18.992 125.065 20.1653 124.276 21.008C123.487 21.84 122.399 22.256 121.012 22.256C119.625 22.256 118.532 21.84 117.732 21.008C116.943 20.1653 116.548 17.488 116.548 10.56H118.196V17.488C118.196 18.5227 118.441 19.328 118.932 19.904C119.433 20.48 120.127 20.768 121.012 20.768C121.897 20.768 122.585 20.48 123.076 19.904C123.577 19.328 123.828 18.5227 123.828 17.488V10.56H125.46ZM130.06 22H128.412V10.56H132.684C133.42 10.56 134.065 10.6987 134.62 10.976C135.175 11.2533 135.607 11.6427 135.916 12.144C136.225 12.6453 136.38 13.2267 136.38 13.888C136.38 14.72 136.14 15.424 135.66 16C135.18 16.576 134.535 16.9493 133.724 17.12L137.468 22H135.42L131.884 17.232H130.06V22ZM132.684 11.984H130.06V15.808H132.684C133.313 15.808 133.809 15.6373 134.172 15.296C134.535 14.9547 134.716 14.4853 134.716 13.888C134.716 13.2907 134.535 12.8267 134.172 12.496C133.809 12.1547 133.313 11.984 132.684 11.984ZM141.248 22H139.6V10.56H143.872C144.608 10.56 145.253 10.6987 145.808 10.976C146.362 11.2533 146.794 11.6427 147.104 12.144C147.413 12.6347 147.568 13.216 147.568 13.888C147.568 14.5493 147.413 15.136 147.104 15.648C146.794 16.1493 146.362 16.5387 145.808 16.816C145.253 17.0933 144.608 17.232 143.872 17.232H141.248V22ZM143.872 11.984H141.248V15.808H143.872C144.501 15.808 144.997 15.6373 145.36 15.296C145.722 14.9547 145.904 14.4853 145.904 13.888C145.904 13.2907 145.722 12.8267 145.36 12.496C144.997 12.1547 144.501 11.984 143.872 11.984ZM156.983 22H149.943V10.56H151.591V20.56H156.983V22ZM166.491 22H159.131V10.56H166.491V11.984H160.779V15.456H166.203V16.88H160.779V20.576H166.491V22Z" fill="white"/>
            </svg>
        </a>`;
    shadowRoot.appendChild(watermarkWrapper);
    return watermarkHost;
};

function create_Lightbox(document, element, item) {
    element.addEventListener('click', function () {
        // Function to create and show the lightbox
        const lightbox = document.createElement('div');
        lightbox.innerHTML = post.create_lightbox(item);
        lightbox.className = 'lightbox';


        document.body.appendChild(lightbox);
    });
}